export default __webpack_public_path__ + "static/media/panel-principal-proveedor.49cb5052.svg";